module.exports = __webpack_public_path__ + "img/e42.69663898.png";